import React from 'react'

interface TaskDeadlineIconProps {
  size?: number
  className?: string
}

export const TaskDeadlineIcon: React.FC<TaskDeadlineIconProps> = ({ size = 16, className }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path d="M8 8.67V1.33L13.33 4L8 6.67M13.71 6.82C14.06 7.91 14.1 9.08 13.8 10.19C13.51 11.3 12.9 12.31 12.06 13.09C11.21 13.86 10.16 14.38 9.03 14.58C7.89 14.78 6.73 14.64 5.67 14.2C4.61 13.75 3.7 13.01 3.05 12.06C2.4 11.11 2.04 10 2 8.85C1.97 7.7 2.26 6.56 2.86 5.58C3.45 4.59 4.31 3.8 5.34 3.29M5.33 6.67C5 7.11 4.78 7.63 4.7 8.18C4.62 8.73 4.68 9.29 4.87 9.82C5.06 10.34 5.38 10.8 5.8 11.17C6.22 11.54 6.72 11.79 7.26 11.92C7.8 12.04 8.37 12.03 8.9 11.88C9.44 11.72 9.93 11.44 10.33 11.05C10.72 10.67 11.02 10.18 11.18 9.65C11.35 9.12 11.38 8.56 11.27 8.01" stroke="currentColor" strokeWidth="1.33" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
)
